import { compose, withProps } from 'recompose'
import withAddToQuote from 'components/common/hoc/withAddToQuote/withAddToQuote'
import withCheckActiveVehicle from 'components/common/hoc/withCheckActiveVehicle'
import AddToQuoteButton from './AddToQuoteButton'

export default compose(
  withAddToQuote,
  withProps(() => ({ skipTireSizeExperience: true })),
  withCheckActiveVehicle
)(AddToQuoteButton)
